import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Typography } from '@web-chat-core/ui-kit';
import { Modal } from 'features/Modals';
import { isFeatureOn } from 'useCase/featureFlags/featureFlagsApi';
import { FEATURES } from 'consts';
import { MicrophoneSection } from './sections/MicrophoneSection/MicrophoneSection';
import { SpeakerSection } from './sections/SpeakerSection/SpeakerSection';
import { CameraSection } from './sections/CameraSection/CameraSection';
import { GeneralSettingsSection } from './sections/GeneralSettingsSection/GeneralSettingsSection';
import { ContentWrapper } from './view';

export const SoundSettingsModal = observer(() => {
    const { t } = useTranslation();

    const vcsSaveSettings = isFeatureOn(FEATURES.VCS_SAVE_SETTINGS);

    return (
        <Modal header={<Typography variant="body1">{t('vks_microphone_audio_camera_settings')}</Typography>}>
            <ContentWrapper>
                <MicrophoneSection />
                <SpeakerSection />
                <CameraSection />
                {vcsSaveSettings && <GeneralSettingsSection />}
            </ContentWrapper>
        </Modal>
    );
});

SoundSettingsModal.displayName = 'SoundSettingsModal';
